import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import FiltersIcon from '../../assets/icons/FiltersIcon';
import { TextButton } from '../../../design-system';
import { device } from '../../styles/devices';
import { Container, FiltersCTA, FilterWrapper, SkipToWrapper } from './SkipTo.styles';
import useScrollTracker from '../../hooks/useScrollTracker';
import { selectZipCode } from '../../reducers/zipCodeReducer';

type StickyNavProps = {
  handleOpenFilters: () => void;
  isFiltersOpen: boolean;
  selectedFiltersCount: number;
  // displayFilterCTA: boolean;
  // onFiltersOpen: () => void;
};

const SkipTo: React.FC<StickyNavProps> = ({
  selectedFiltersCount,
  handleOpenFilters,
  isFiltersOpen,
}) => {
  const { t } = useTranslation();
  const isAlpha = !process.env.IS_LEGACY;
  const isLaptop = useMediaQuery({ query: device.laptop });
  const isTablet = useMediaQuery({ query: device.tablet });

  const stickyRef = useRef<HTMLDivElement>(null);

  const { confirmedZipcode, market } = useSelector(selectZipCode);
  const hasZip = confirmedZipcode !== '';
  const isCaMarket = market === 'CA';

  const mobileScrolled = useScrollTracker(340);

  const isSticky = mobileScrolled && !isLaptop;
  const showAlphaElevation = isAlpha && isSticky;

  let baseLabel: string;

  if (isAlpha && isCaMarket) {
    baseLabel = isLaptop ? t('promo.filters.showFilters') : t('promo.filters.openFilterCta');
  } else if (isAlpha && hasZip) {
    baseLabel = isLaptop
      ? t('promo.filters.showFilters')
      : t('promo.filters.openFilterCtaWithLocation');
  } else {
    if (isLaptop) {
      baseLabel = t('promo.filters.showFilters');
    } else if (isTablet) {
      baseLabel = t('promo.filters.openFilterCta');
    } else {
      baseLabel = t('promo.filters.openFilterCtaMobile');
    }
  }

  const label = `${baseLabel}${selectedFiltersCount ? ` (${selectedFiltersCount})` : ''}`;

  return (
    <SkipToWrapper>
      <Container
        ref={stickyRef}
        isStuck={isSticky}
        isFiltersOpen={isFiltersOpen}
        isAlpha={isAlpha}
        showAlphaElevation={showAlphaElevation}
      >
        {!isLaptop && (
          <FilterWrapper>
            {isAlpha ? (
              <TextButton
                variant="secondary"
                icon="options"
                iconPosition="leading"
                onClick={handleOpenFilters}
                data-testid="filters-cta"
              >
                {label}
              </TextButton>
            ) : (
              <FiltersCTA data-testid="filters-cta" onClick={handleOpenFilters}>
                <FiltersIcon />
                {label}
              </FiltersCTA>
            )}
          </FilterWrapper>
        )}
      </Container>
    </SkipToWrapper>
  );
};

export default SkipTo;
